<template>
  <div class="canvas">
    <TopBar @saved="handleSaved"></TopBar>
    <Control ref="control"></Control>
  </div>
</template>

<script>
import TopBar from "@/components/TopBar/index.vue";
import Control from "@/components/Control/index.vue";
export default {
  data() {
    return {};
  },
  methods: {
    handleSaved() {
      this.$refs.control.refreshAiTextAfterSave();
    },
  },
  components: {
    TopBar,
    Control,
  },
};
</script>

<style scoped></style>
